export default __webpack_public_path__ + "508bde7108f66926f455b87fa71e4e1e.png";